import React, { useEffect } from 'react';
import DetailCard from './DetailCard';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUploadedFile } from '../../../../redux/slice/filesUploadSlice';
import { useParams } from 'react-router-dom';

const AllDoumentsList = () => {

    const dispatch = useDispatch();
    const params = useParams();
    const { allFiles, fetchAllStatus } = useSelector((state) => state.filesUpload);
    const InitialPermissionData = useSelector(
        (state) => state.persistedReducer.forms.savedPermissions
    );
    const { userId } = InitialPermissionData ?? {};
    const idFromParams = params?.id;  // EmpID
    const idToUse = idFromParams ?? userId;
    useEffect(() => {
        if (userId) {
            dispatch(getAllUploadedFile(idToUse));
        }
    }, [dispatch, idToUse]);

    return (
        <div className="container-fluid">
            {/* Grid of Cards */}
            <div className="doc-card">
                {fetchAllStatus === "loading" && (<p className="loading">Loading...</p>)}
                {fetchAllStatus === "failed" && (<p className="server-error-msg">Unable to connect to server</p>)}
                {fetchAllStatus == "succeeded" && (
                    <>
                        {Array.isArray(allFiles) ? allFiles.map((data, id) => (
                            <DetailCard key={id} title={data.fileType} userId={idToUse}
                                iconClass="bi bi-envelope-check" bgColor="bg-teal-light"
                            />
                        )) : <p className="loading">No files found</p>
                        }
                        {allFiles?.length === 0 && <p className="loading">No files found</p>}
                    </>
                )}
            </div>
        </div>
    );
};

export default AllDoumentsList;
